<template>
    <div class="result-hero-wrapper">
        <div class="container">
            <div class="col result-hero-container">
                <div class="result-hero-details">
                    <div class="details">
                        <div class="title">
                            <span class="greetingDetail">
                                {{ $t('contactPage.contactUs') }}
                            </span>
                        </div>

                        <div class="details-description">
                            <span>{{ $t('contactPage.hearFromYou') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    setup() {
        return {}
    },
    props: {},

    data() {
        return {}
    },

    computed: {},

    methods: {},
}
</script>
